import { render, staticRenderFns } from "./LogoCarousel.vue?vue&type=template&id=5f88e3ea&scoped=true&"
import script from "./LogoCarousel.vue?vue&type=script&lang=ts&"
export * from "./LogoCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./LogoCarousel.vue?vue&type=style&index=0&id=5f88e3ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f88e3ea",
  null
  
)

export default component.exports